<script setup lang="ts"></script>

<template>
  <span>
    <slot />
  </span>
</template>
